<div class="divBackground" (click)="touchCloseModal()">

  <div class="divCentral">
  <ion-img src="../../../assets/image/wellcome/img-wellcome.png"></ion-img>
  </div>

</div>
